import { useNavigate } from "react-router-dom";

export function CameraButton() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="CameraButton"
      onClick={() => navigate("/app/camera")}
      aria-label="Open camera"
      title="Open camera"
    >
      Camera
    </button>
  );
}